/*VARIABLES*/

import images from './images';

const fillCanvas = () => {
  window.onload = () => {};
  var canvas = document.getElementById('canvasForSkills');
  canvas.width = document.body.clientWidth;
  canvas.height = 600; //document.body.clientHeight;

  var ctx = canvas.getContext('2d');

  /*Modify options here*/

  //possible characters that will appear
  var characterList = images.map(x => x.src);

  //stocks possible character attributes
  var layers = {
    n: 5, //number of layers
    letters: [15, 15, 10, 10, 5], //letters per layer (starting from the deepest layer)
    coef: [0.1, 0.2, 0.3, 0.4, 0.5], //how much the letters move from the mouse (starting from the deepest layer)
    size: [5, 5, 5, 5, 5], //font size of the letters (starting from the deepest layer)
    color: ['#fff', '#eee', '#ccc', '#bbb', '#aaa'], //color of the letters (starting from the deepest layer)
    font: 'Courier', //font family (of every layer)
  };

  /*End of options*/

  var characters = [];
  var mouseX = document.body.clientWidth / 2;
  var mouseY = document.body.clientHeight / 2;

  var rnd = {
    btwn: function (min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    choose: function (list) {
      return list[rnd.btwn(0, list.length)];
    },
  };

  /*LETTER DRAWING*/

  function drawLetter(char) {
    // ctx.font = char.size + 'px ' + char.font;
    ctx.fillStyle = char.color;

    var x = char.posX + (mouseX - canvas.width / 2) * char.coef;
    var y = char.posY + (mouseY - canvas.height / 2) * char.coef;
    const image = new Image(10, 10); // Using optional size for image
    // image.onload = drawImageActualSize; // Draw when image has loaded

    // Load an image of intrinsic size 300x227 in CSS pixels
    image.src = char.char;
    // image.style.opacity = 0; //char.coef;
    // image.width = '40px';
    // image.height = '40px';
    var size = 50;

    ctx.drawImage(image, x, y, size + char.layer * 5, size + char.layer * 5);
  }

  /*ANIMATION*/

  document.onmousemove = function (ev) {
    mouseX = ev.pageX - canvas.offsetLeft;
    mouseY = ev.pageY - canvas.offsetTop;

    if (window.requestAnimationFrame) {
      requestAnimationFrame(update);
    } else {
      update();
    }
  };

  function update() {
    clear();
    render();
  }

  function clear() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  function render() {
    for (var i = 0; i < characters.length; i++) {
      drawLetter(characters[i]);
    }
  }

  /*INITIALIZE*/

  function createLetters() {
    for (var i = 0; i < layers.n; i++) {
      for (var j = 0; j < layers.letters[i]; j++) {
        var character = rnd.choose(characterList);
        var x = rnd.btwn(0, canvas.width);
        var y = rnd.btwn(0, canvas.height);

        characters.push({
          char: character,
          font: layers.font,
          size: layers.size[i],
          color: layers.color[i],
          layer: i,
          coef: layers.coef[i],
          posX: x,
          posY: y,
        });
      }
    }
  }

  createLetters();
  update();
};

export default fillCanvas;
